module.exports = __webpack_public_path__ + "assets/img/gar8-5.a2c4b5ae.jpg";